import { IGetNewAllSession } from "./../../../../interfaces/course-getNewAllSession";
import { CommonHttpOption } from "./../../base/common-http-option";
import { Injectable, EventEmitter, Output } from "@angular/core";
import { CoreService } from "../../base/core";
import { Observable } from "rxjs";
import { ServiceRoute } from "../../base/service-route";
import { IGetFullTimeSession } from "src/app/interfaces/get-fullTime-session";
import { IAddTeacherAfterCourse } from "src/app/interfaces/course-addTeacherAfterCourse";
import { IGetFreeTeacherAfterCourse } from "src/app/interfaces/course-getFreeTeacherAfterCourse";
import { IGetFreeTeacherInAddEditCourse } from "src/app/interfaces/course-getFreeTeacherInAddEditCourse";
import { IGetFirstDate } from "src/app/interfaces/course-getFirstDate";
import { HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root"
})
export class CourseService {
  constructor(private core: CoreService) { }

  @Output() change: EventEmitter<boolean> = new EventEmitter();

  Add(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.course.Add,
      data,
      new CommonHttpOption().headers
    );
  }

  AghAdd(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.course.AghAdd,
      data,
      new CommonHttpOption().headers
    );
  }

  AghList(customerContractId: Number, NationalCode: string): Observable<any> {
    debugger
    return this.core.get(
      ServiceRoute.course.AghList + customerContractId + ('&NationalCode=' + ((NationalCode) ? NationalCode : '')),
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(0, 0, "Id", true)
    );
  }



  UpdateFinalExamDate(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.course.UpdateFinalExamDate,
      data,
      new CommonHttpOption().headers
    );
  }



  edit(data: any): Observable<any> {
    return this.core.put(
      ServiceRoute.course.edit,
      data,
      new CommonHttpOption().headers
    );
  }


  CourseChangeRoom(data: any): Observable<any> {
    return this.core.put(
      ServiceRoute.course.CourseChangeRoom,
      data,
      new CommonHttpOption().headers
    );
  }

  GetNewAllSession(data: IGetNewAllSession): Observable<any> {
    return this.core.post(
      ServiceRoute.course.GetNewAllSession,
      data,
      new CommonHttpOption().headers
    );
  }
  getCourseForeMakeUp(filter: any): Observable<any> {
    return this.core.get(
      ServiceRoute.course.GetCourseForeMakeUp,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator("Id", true)
        .append('BranchEncryptId', filter && filter.BranchEncryptId ? filter.BranchEncryptId : '')
        .append('TermInfoId', filter && filter.TermInfoId ? filter.TermInfoId : '')
        .append('CoursePatternId', filter && filter.CoursePatternId ? filter.CoursePatternId : '')
    );
  }
  GetFullTimeSession(data: IGetFullTimeSession): Observable<any> {
    return this.core.post(
      ServiceRoute.course.GetFullTimeSession,
      data,
      new CommonHttpOption().headers
    );
  }

  GetPrivateCoursePrice(courseId: number): Observable<any> {
    return this.core.get(
      ServiceRoute.course.GetPrivateCoursePrice + courseId,
      new CommonHttpOption().headers
    );
  }

  SetPrivateCoursePrice(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.course.SetPrivateCoursePrice,
      data,
      new CommonHttpOption().headers
    );
  }

  SavePrivateClassRequest(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.course.SavePrivateClassRequest,
      data,
      new CommonHttpOption().headers
    );
  }

  DeletePrivateClassRequest(data: any): Observable<any> {
    return this.core.delete(
      ServiceRoute.course.DeletePrivateClassRequest,
      new CommonHttpOption().headers,
      data
    );
  }

  SetPrivateClassRequestReviewed(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.course.SetPrivateClassRequestReviewed,
      data,
      new CommonHttpOption().headers
    );
  }

  adobeConnectLogin(nationalCode: string): Observable<any> {
    debugger
    return this.core.getWithUrl(
      environment.AdobeConnect + "/api/xml?action=login&login=" + nationalCode + "&password=" + nationalCode
    );
  }

  createMeeting(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.adobeConnect.createMeeting,
      data,
      new CommonHttpOption().headers
    );
  }

  showSessionArchive(sessionId: number): Observable<any> {
    return this.core.get(
      ServiceRoute.adobeConnect.showSessionArchive + sessionId,
      new CommonHttpOption().headers
    );
  }

  createMeetingForOneSession(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.adobeConnect.createMeetingForOneSession,
      data,
      new CommonHttpOption().headers
    );
  }

  addTeacherToVirtualCourse(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.adobeConnect.addTeacherToVirtualCourse,
      data,
      new CommonHttpOption().headers
    );
  }

  addStudentToVirtualCourse(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.adobeConnect.addStudentToVirtualCourse,
      data,
      new CommonHttpOption().headers
    );
  }

  addStudentToVirtualSession(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.adobeConnect.addStudentToVirtualSession,
      data,
      new CommonHttpOption().headers
    );
  }

  getCourseForEdit(data: any) {
    return this.core.post(
      ServiceRoute.course.getCourseForEdit,
      data,
      new CommonHttpOption().headers
    );
  }

  AddTeacherAfterCourse(data: IAddTeacherAfterCourse): Observable<any> {
    return this.core.post(
      ServiceRoute.course.AddTeacherAfterCourse,
      data,
      new CommonHttpOption().headers
    );
  }

  addSupervisorToVirtualCourse(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.adobeConnect.addSupervisorToVirtualCourse,
      data,
      new CommonHttpOption().headers
    );
  }

  CourseBatchClassDefinitionInNewTearm(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.course.CourseBatchClassDefinitionInNewTearm,
      data,
      new CommonHttpOption().headers
    );
  }

  CourseBatchClassDelete(data: any): Observable<any> {
    return this.core.delete(
      ServiceRoute.course.CourseBatchClassDelete,
      new CommonHttpOption().headers,
      data
    );
  }

  RemoveTeacherFromCourse(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.course.RemoveTeacherFromCourse,
      data,
      new CommonHttpOption().headers
    );
  }



  SaveMakeUp(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.course.SaveMakeUp,
      data,
      new CommonHttpOption().headers
    );
  }

  SubSave(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.course.SubSave,
      data,
      new CommonHttpOption().headers
    );
  }

  GetFreeTeacherAfterCourse(data: IGetFreeTeacherAfterCourse): Observable<any> {
    return this.core.post(
      ServiceRoute.course.GetFreeTeacherAfterCourse,
      data,
      new CommonHttpOption().headers
    );
  }

  GetFreeTeacherInAddEditCourse(
    data: IGetFreeTeacherInAddEditCourse
  ): Observable<any> {
    return this.core.post(
      ServiceRoute.course.GetFreeTeacherInAddEditCourse,
      data,
      new CommonHttpOption().headers
    );
  }

  getFreeSubTeacher(
    data: any
  ): Observable<any> {
    return this.core.post(
      ServiceRoute.course.GetFreeSubTeacher,
      data,
      new CommonHttpOption().headers
    );
  }

  getFirstDate(data: IGetFirstDate): Observable<any> {
    return this.core.post(
      ServiceRoute.course.GetFirstDate,
      data,
      new CommonHttpOption().headers
    );
  }

  list(filter: any, page: number = 1, pageSize: number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.course.list,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize, "Id", true)
        .append('Id', filter && filter.Id ? filter.Id : '')
        .append('BranchEncryptId', filter && filter.BranchEncryptId ? encodeURI(filter.BranchEncryptId) : '')
        .append('CoursePatternId', filter && filter.CoursePatternId ? filter.CoursePatternId : '')
        .append('TermInfoId', filter && filter.TermInfoId ? filter.TermInfoId : '')
        .append('TermNumber', filter && filter.TermNumber ? filter.TermNumber : '')
        .append('PackageId', filter && filter.PackageId ? filter.PackageId : '')
        .append('LevelInfoId', filter && filter.LevelInfoId ? filter.LevelInfoId : '')
        .append('RoomName', filter && filter.RoomName ? filter.RoomName : '')
        .append('CourseStatusId', filter && filter.CourseStatusId ? filter.CourseStatusId : '')
    );
  }

  getPrivateClassRequestForAdmin(page: number = 1, pageSize: number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.course.GetPrivateClassRequestForAdmin,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  getPrivateClassRequestForUser(page: number = 1, pageSize: number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.course.GetPrivateClassRequestForUser,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  listByCompany(filter: any, page: number = 1, pageSize: number = 10, headers: HttpHeaders): Observable<any> {
    return this.core.get(
      ServiceRoute.course.list,
      headers,
      new CommonHttpOption().paginator(page, pageSize, "Id", true)
        .append('Id', filter && filter.Id ? filter.Id : '')
        .append('BranchEncryptId', filter && filter.BranchEncryptId ? encodeURI(filter.BranchEncryptId) : '')
        .append('CoursePatternId', filter && filter.CoursePatternId ? filter.CoursePatternId : '')
        .append('TermInfoId', filter && filter.TermInfoId ? filter.TermInfoId : '')
        .append('TermNumber', filter && filter.TermNumber ? filter.TermNumber : '')
        .append('Year', filter && filter.Year ? filter.Year : '')
        .append('PackageId', filter && filter.PackageId ? filter.PackageId : '')
        .append('LevelInfoId', filter && filter.LevelInfoId ? filter.LevelInfoId : '')
        .append('ParentTermId', filter && filter.ParentTermId ? filter.ParentTermId : '')
        .append('RoomName', filter && filter.RoomName ? filter.RoomName : '')
        .append('CourseStatusId', filter && filter.CourseStatusId ? filter.CourseStatusId : '')
        .append('DiscountGroupId', filter && filter.DiscountGroupId ? filter.DiscountGroupId : '')
        .append('CourseTypeId', filter && filter.CourseTypeId ? filter.CourseTypeId : '')
    );
  }

  listByBranch(
    branch: String,
    page: number = 1,
    pageSize: number = 10
  ): Observable<any> {
    return this.core.get(
      ServiceRoute.course.list + branch,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  delete(data: any): Observable<any> {
    return this.core.delete(
      ServiceRoute.course.delete,
      new CommonHttpOption().headers,
      data
    );
  }

  cancelCourse(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.course.cancelCourse,
      data,
      new CommonHttpOption().headers
    );
  }
  activeCourse(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.course.activeCourse,
      data,
      new CommonHttpOption().headers
    );
  }

  subDelete(data: any): Observable<any> {
    return this.core.delete(
      ServiceRoute.course.SubDelete,
      new CommonHttpOption().headers,
      data
    );
  }

  makeUpDelete(data: any): Observable<any> {
    return this.core.delete(
      ServiceRoute.course.MakeUpDelete,
      new CommonHttpOption().headers,
      data
    );
  }

  getListIndeterminate(data: IGetFreeTeacherAfterCourse): Observable<any> {
    return this.core.post(
      ServiceRoute.course.GetListIndeterminate,
      data,
      new CommonHttpOption().headers
    );
  }

  saveAttendanceWithNoDate(data: any): Observable<any>
  {
    return this.core.post(
      ServiceRoute.course.saveAttendanceWithoutDate,
      data,
      new CommonHttpOption().headers
    );
  }


  getAttendance(parentTermId: number, branchencryptId: string, dateNoew: Date): Observable<any> {
    return this.core.get(
      ServiceRoute.course.getAttendance +
      parentTermId +
      "&BranchEncryptId=" +
      branchencryptId +
      "&DateNow=" +
      dateNoew,
      new CommonHttpOption().headers
    );
  }
  getCourseSessionNotPresent(id: number): Observable<any> {
    return this.core.get(
      ServiceRoute.course.getCourseSessionNotPresent +
      id,
      new CommonHttpOption().headers
    );
  }

  getCourseSession(id: number): Observable<any> {
    return this.core.get(
      ServiceRoute.course.GetCourseSession +
      id,
      new CommonHttpOption().headers
    );
  }

  saveAttendance(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.course.saveAttendance,
      data,
      new CommonHttpOption().headers
    );
  }

  SendSMSToPerson(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.course.SendSMSToPerson,
      data,
      new CommonHttpOption().headers
    );
  }

  SendSMSToClass(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.course.SendSMSToClass,
      data,
      new CommonHttpOption().headers
    );
  }

  SendSMSToPattern(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.course.SendSMSToPattern,
      data,
      new CommonHttpOption().headers
    );
  }

  fire() {
    this.change.emit();
  }

  getTPAItemList(courseId: number): Observable<any> {
    return this.core.get(
      ServiceRoute.course.GetTPAItemList + courseId,
      new CommonHttpOption().headers
    );
  }

  GetTPADataDetails(tpaDataGroupId: number): Observable<any> {
    return this.core.get(
      ServiceRoute.course.GetTPADataDetails + tpaDataGroupId,
      new CommonHttpOption().headers
    );
  }

  getTPADataList(courseId: number): Observable<any> {
    return this.core.get(
      ServiceRoute.course.GetTPADataList + courseId,
      new CommonHttpOption().headers
    );
  }

  getTPADataListAll(): Observable<any> {
    return this.core.get(
      ServiceRoute.course.GetTPADataListAll,
      new CommonHttpOption().headers
    );
  }

  saveTeacherTPAItem(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.course.SaveTeacherTPAItem,
      data,
      new CommonHttpOption().headers
    );
  }

  deleteTeacherTPAData(data: any): Observable<any> {
    return this.core.delete(
      ServiceRoute.course.DeleteTeacherTPAData,
      new CommonHttpOption().headers,
      data
    );
  }

  getCourseInfoById(params: any): Observable<any>
  {
    return this.core.get(
      ServiceRoute.course.getCourseInfobyId,
      new CommonHttpOption().headers,
      params
    );
  }
}
